import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { login } from '../api/api';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../context/Context';
import { toast } from 'react-toastify';
import FormError from '../components/FormError';

function Login() {
    const redirect = useNavigate(null);
    const { adminData, setAdminData, getUserType } = useContext(MyContext);
    const [inputValue, setInputValue] = useState({
        username: "",
        password: "",
    });
    const [formError, setFormError] = useState({
        username: "",
        password: "",
    })

    //--------------change handle--------------//
    const handle_change = (e) => {
        const { name, value } = e.target

        setInputValue({
            ...inputValue,
            [name]: value
        })
    };


    //--------------Login api call--------------//
    const login_Api_call = async () => {
        const { username, password } = inputValue

        const errors = {};

        if (!username) {
            errors.username = 'Please Enter User Name!'
        }
        if (!password) {
            errors.password = 'Please Enter Password!'
        }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }

        const data = {
            username: inputValue.username,
            password: inputValue.password,
        };

        try {
            const res = await login(data);

            if (res.status === 200) {
                localStorage.setItem('token', res.data.data[0].api_token);
                localStorage.setItem('admin_data', JSON.stringify(res.data.data[0]));
                setAdminData(res.data.data[0]);

                getUserType()
                toast.success("Login Successful");
                redirect('/dashboard');
            } else {
                redirect('/');
            }
        } catch (error) {
            console.error("Error during login:", error);
            toast.error("Invalid Username and password!");
            redirect('/');
        }
    }

    return (
        <Section className="hold-transition login-page">
            <div className="login-box">
                <div className="login-logo">
                    <img src="dist/img/loading_screen_logo.png" height={80} width={80} alt="login logo" />
                </div>
                {/* login-logo */}
                <div className="card">
                    <div className="card-body login-card-body">
                        <p className="login-box-msg">
                            <span className='title'>
                                welcome to naariyal paniwala
                            </span>
                            <span className='sub-title'>
                                har roz naariyal pani aapke ghar
                            </span>
                        </p>
                        <form
                            id="login_for"
                        >
                            <div className="mb-3">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control text-lowercase"
                                        placeholder="Username"
                                        value={inputValue.username}
                                        name='username'
                                        onChange={handle_change}
                                    />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-envelope" />
                                        </div>
                                    </div>
                                </div>
                                <FormError>
                                    {formError.username ? formError.username : ''}
                                </FormError>
                            </div>
                            <div className="mb-3">
                                <div className="input-group">
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="Password"
                                        value={inputValue.password}
                                        name='password'
                                        onChange={handle_change}
                                    />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-lock" />
                                        </div>
                                    </div>
                                </div>
                                <FormError>
                                    {formError.password ? formError.password : ''}
                                </FormError>
                            </div>

                        </form>
                        <div className="login-button mb-3">
                            <button
                                className="btn btn-block"
                                onClick={login_Api_call}
                            >
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default Login

const Section = styled.div`

    .card-body {
        border-radius: 10px;
    }

    .login-box-msg {
        display: flex;
        flex-direction: column;
        padding: 10px 0 25px;
    }

    .login-box-msg .title {
        text-transform: capitalize;
        font-size: 20px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.green};
    }

    .login-box-msg .sub-title {
        text-transform: capitalize;
        font-size: 15px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.black};
    }

    .login-button button {
        background-color: ${({ theme }) => theme.colors.green};
        color: ${({ theme }) => theme.colors.white};
        transition: all 0.3s;

        &:active {
            scale: 0.95;
        }
        
    }
    
`;

